import { Text } from '@components/text';

import { useFileTranslations } from './locale';

export type FileAcceptTextProps = {
  accept?: string;
};

export const FileAcceptText = ({ accept }: FileAcceptTextProps) => {
  const { t } = useFileTranslations();
  if (!accept) return null;

  return <Text font="regular14" color="purple60" text={`${t('accepted')} ${accept}`} />;
};
